export default "__VITE_ASSET__BDaR6CLB__"